import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import {
  getStudentIdData,
  getStudentIdDataWithStatus,
} from "../../../lib/taskmanageview";
import StudentInfoBoxWithData from "../studentGrid/studentinfoboxwithdata";
import { logopcp } from "../../imagepath";

export default function Tasks() {
  const [tasklist, setTaskList] = useState([]);
  const [collapseOpenClose, setCollapseOpenClose] = useState(false);
  const [tab, setTab] = useState(1);
  let { slug } = useParams();
  const navigate = useNavigate();
  const componentRef = useRef();

  const collapseAll = () => {
    setCollapseOpenClose(!collapseOpenClose);
  };

  async function GetStudentData() {
    let tasks;

    if (tab === 1) tasks = await getStudentIdData(slug);
    if (tab === 2) tasks = await getStudentIdDataWithStatus(slug, "Current");
    if (tab === 3) tasks = await getStudentIdDataWithStatus(slug, "Later");
    if (tab === 4) tasks = await getStudentIdDataWithStatus(slug, "Closed");

    setTaskList(tasks);
  }

  useEffect(() => {
    GetStudentData();
    setTab(2);
  }, [tab, slug]);

  const toggleTab = (id) => setTab(id);

  const handlePrint = useReactToPrint({
    content: () => {
      removeBorderClasses();
      return componentRef.current;
    },
    onAfterPrint: () => {
      restoreBorderClasses();
    },
  });

  const removeBorderClasses = () => {
    const elements = document.querySelectorAll(
      ".border.border-3.border-primary"
    );
    const transcriptDiv = document.getElementById("transcript_div_pdf");
    const pdfLogo = document.getElementById("pdf_logo");

    if (transcriptDiv) {
      transcriptDiv.classList.add("pdf_transcript_div");
      transcriptDiv.classList.remove("transcript_div");
    }

    if (pdfLogo) {
      pdfLogo.style.display = "block";
    }

    elements.forEach((element) => {
      element.classList.add("border-hidden");
      element.classList.remove("border", "border-3", "border-primary");
    });
  };

  const restoreBorderClasses = () => {
    const elements = document.querySelectorAll(".border-hidden");
    const transcriptDiv = document.getElementById("transcript_div_pdf");
    const pdfLogo = document.getElementById("pdf_logo");

    if (transcriptDiv) {
      transcriptDiv.classList.remove("pdf_transcript_div");
      transcriptDiv.classList.add("transcript_div");
    }

    if (pdfLogo) {
      pdfLogo.style.display = "none";
    }

    elements.forEach((element) => {
      element.classList.add("border", "border-3", "border-primary");
      element.classList.remove("border-hidden");
    });
  };

  return (
    <div className="settings-widget">
      <div className="settings-inner-blk p-0">
        <div className="comman-space pb-0">
          <div className="d-flex align-items-center justify-content-between mb-3">
            <button
              onClick={() => navigate(-1)}
              className="btn btn-black btn-sm"
            >
              {"<< Back"}
            </button>
            <h3>Agenda</h3>
            <button
              onClick={handlePrint}
              className="btn btn-info-light next_btn"
              style={{ backgroundColor: "blue", color: "white" }}
            >
              Print Page
            </button>
          </div>
          <div className="card wish-card" ref={componentRef}>
            <div className="card wish-card">
              <div className="card-header">
                <StudentInfoBoxWithData slug={slug} taskshow={false} />
                <img
                  src={logopcp}
                  className="img-fluid pdf_logo"
                  id="pdf_logo"
                  alt="Logo"
                  style={{ display: "none" }}
                />
              </div>
            </div>
            <div className="page-break">
              <div className="category-tab tickets-tab-blk mt-4">
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <ul className="nav nav-justified d-flex">
                    <li className="nav-item">
                      <Link
                        className={tab === 1 ? "nav-link active" : "nav-link"}
                        onClick={(e) => {
                          e.preventDefault();
                          toggleTab(1);
                        }}
                      >
                        All
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        className={tab === 2 ? "nav-link active" : "nav-link"}
                        onClick={(e) => {
                          e.preventDefault();
                          toggleTab(2);
                        }}
                      >
                        Current
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        className={tab === 3 ? "nav-link active" : "nav-link"}
                        onClick={(e) => {
                          e.preventDefault();
                          toggleTab(3);
                        }}
                      >
                        Later
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        className={tab === 4 ? "nav-link active" : "nav-link"}
                        onClick={(e) => {
                          e.preventDefault();
                          toggleTab(4);
                        }}
                      >
                        Closed
                      </Link>
                    </li>
                  </ul>
                  <button
                    className="btn btn-outline-info"
                    onClick={collapseAll}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      fill="currentColor"
                      className="bi bi-chevron-double-down"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fillRule="evenodd"
                        d="M1.646 6.646a.5.5 0 0 1 .708 0L8 12.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                      />
                      <path
                        fillRule="evenodd"
                        d="M1.646 2.646a.5.5 0 0 1 .708 0L8 8.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                      />
                    </svg>{" "}
                    Collapse All
                  </button>
                </div>
              </div>
              <div className="tab-content">
                <div className="settings-tickets-blk table-responsive">
                  <table className="table table-nowrap mb-0">
                    <thead>
                      <tr>
                        <th>Topic</th>
                        <th>Student</th>
                        <th>Date</th>
                        <th>Status</th>
                        <th>Detail</th>
                      </tr>
                    </thead>
                    <tbody>
                      {tasklist.map((data) => (
                        <>
                          <tr key={data.id}>
                            <td>
                              <span>{data.subject}</span>
                            </td>
                            <td>{data.studentinfo}</td>
                            <td>{data.setDate}</td>
                            <td>{data.statusway}</td>
                            <td>
                              <a
                                className="btn btn-outline-info"
                                data-bs-toggle="collapse"
                                href={`#collapseExample${data.id}`}
                                role="button"
                                aria-expanded="false"
                                aria-controls={`collapseExample${data.id}`}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="18"
                                  height="18"
                                  fill="currentColor"
                                  className="bi bi-chevron-double-down"
                                  viewBox="0 0 16 16"
                                >
                                  <path
                                    fillRule="evenodd"
                                    d="M1.646 6.646a.5.5 0 0 1 .708 0L8 12.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                                  />
                                  <path
                                    fillRule="evenodd"
                                    d="M1.646 2.646a.5.5 0 0 1 .708 0L8 8.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                                  />
                                </svg>{" "}
                                Details
                              </a>
                            </td>
                          </tr>
                          <tr
                            className={`collapse ${
                              collapseOpenClose ? "show" : ""
                            }`}
                            id={`collapseExample${data.id}`}
                          >
                            <td
                              colSpan={5}
                              style={{ width: "auto", paddingLeft: "15px" }}
                              className="fw-bold "
                            >
                              {/* {data.desc} */}
                              <div
                                style={{ lineHeight: "1.6", marginTop: "10px" }}
                                dangerouslySetInnerHTML={{ __html: data.desc }}
                              />
                            </td>
                          </tr>
                        </>
                      ))}
                    </tbody>
                  </table>
                  <span className="border border-3 border-primary"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
